import {createContext, useContext} from 'react';
import {DailyCareLogFiltersType} from './types';

// Create Context
export const DailyCareLogFiltersContext = createContext<DailyCareLogFiltersType>(
  {} as DailyCareLogFiltersType
);

// Encapsulated context hook
export const useDailyCareLogFilters = () => useContext(DailyCareLogFiltersContext);
